import styled from '@emotion/styled';
import { commonColors } from 'application/theme';

interface PageButtonProps {
  currentPage: boolean;
}

export const Wrapper = styled.section`
  display: flex;
  border-radius: 12px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-top: 1px solid ${commonColors.grey300};
  background: ${commonColors.white};
  padding: 12px 24px 16px 24px;
  justify-content: space-between;
  align-items: center;

  > button {
    width: fit-content;
  }
  > div {
    display: flex;
    align-items: center;
    color: ${commonColors.grey500};
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    line-height: 140%;
  }
`;

export const PageButton = styled.button<PageButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  color: ${({ currentPage }) =>
    currentPage ? commonColors.grey800 : commonColors.grey500};
  font-size: 14px;
  font-weight: ${({ currentPage }) => (currentPage ? '600' : '500')};
  line-height: 19.6px;
  background: ${({ currentPage }) =>
    currentPage ? commonColors.blue200 : commonColors.white};
`;

export const ButtonStyled = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 6px 16px;
  gap: 10px;
  width: 100%;
  height: 48px;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.08px;
  color: ${commonColors.grey700};
  background-color: transparent;
  border: 1px solid ${commonColors.grey400};
  box-shadow: 1px 1px 2px rgba(16, 24, 40, 0.12);
  border-radius: 8px;
  cursor: pointer;

  :hover {
    background-color: ${commonColors.grey100};
    color: ${commonColors.grey900};
  }

  :disabled {
    background-color: ${commonColors.white};
    border-color: ${commonColors.grey300};
    color: ${commonColors.grey300};
  }
`;
